if (!customElements.get('cart-reserve-timer')) {
  const RESERVE_SECONDS = 300;
  const STORAGE_KEY = 'cart-reserve-deadline';

  const getDeadline = () => {
    let deadline = 0;
    try {
      deadline = parseInt(sessionStorage.getItem(STORAGE_KEY), 10) || 0;
    } catch (e) {}
    if (deadline <= Date.now()) {
      deadline = Date.now() + RESERVE_SECONDS * 1000;
      try {
        sessionStorage.setItem(STORAGE_KEY, deadline);
      } catch (e) {}
    }
    return deadline;
  };

  customElements.define(
    'cart-reserve-timer',
    class CartReserveTimer extends HTMLElement {
      connectedCallback() {
        this.output = this.querySelector('[data-reserve-time]');
        this.tick();
        this.interval = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.interval);
      }

      tick() {
        const remaining = Math.max(0, Math.round((getDeadline() - Date.now()) / 1000));
        const minutes = String(Math.floor(remaining / 60)).padStart(2, '0');
        const seconds = String(remaining % 60).padStart(2, '0');
        this.output.textContent = `${minutes}:${seconds}`;
      }
    }
  );
}
